import { Column, Divider, H2, Link, Row, Box } from "@vp/swan";
import React from "react"
import SubCategory from "../SubCategory"

import "../../styles/styles.css"

const Category = props => {
  return (
    <Box mb="7">
      <Row>
        <Column span={12}>
          <H2 className="category-header" fontSize={"x2large"} mb={"5"}>
            {props.category.isAvailable
              ? (
              <Link
                data-fidoprefetchhint="HOVER"
                href={props.category.url}
              >
                {props.category.name}
              </Link>
            ) : (
              props.category.name
            )}
          </H2>
          <Divider />
        </Column>
      </Row>
      {
        props.category.children.length > 0 &&
          <Row>
            {props.category.children.map((subCategory, index) => {
              return (
                <Column key={`${props.key}_${index}`} span={3} mt={"5"}>
                  <SubCategory
                    subCategory={subCategory}
                  />
                </Column>
              );
            })}
          </Row>
      }
    </Box>
  )
}

export default Category
